import { Component, OnInit, Input } from '@angular/core';
import { Course } from '../../models/course';
import { CourseService } from 'src/app/services/course.service';
import { FileService } from 'src/app/services/file.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  @Input('course') course: Course;
  @Input('loggedIn') loggedIn: boolean;
  @Input('userCanWatch') userCanWatch: boolean;
  public documents:Document[]=[];

  constructor(
    private _courseService:CourseService,
    private _fileService:FileService
  ) {}

  public downloadCourseDocument(filename:string){
    if(!this.loggedIn || !this.userCanWatch) {
      return alert('You must be logged in and have access to this Video to download documents.');
    }
    this._fileService.downloadFile(`/api/course/document/${filename}`).subscribe(data=>{
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download =filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    })
  }

  public downloadCourseDocument2(id:number){
    if(!this.loggedIn || !this.userCanWatch) {
      return alert('You must be logged in and have access to this Video to download documents.');
    }
    console.log(environment.apiEndpoint+'/documentdownload/'+id+'/'+localStorage.getItem('token'));
    window.open(environment.apiEndpoint+'/documentdownload/'+id+'/'+localStorage.getItem('token'), '_blank');
    // this._fileService.downloadFile(`/api/course/document/${filename}`).subscribe(data=>{
    //   let url = window.URL.createObjectURL(data);
    //   let a = document.createElement('a');
    //   document.body.appendChild(a);
    //   a.setAttribute('style', 'display: none');
    //   a.href = url;
    //   a.download =filename;
    //   a.click();
    //   window.URL.revokeObjectURL(url);
    //   a.remove();
    // })
  }

  ngOnInit() {
    this._courseService.getDocuments(this.course.id).subscribe(data=>{
      this.documents=data;
    });
  }

}
